<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajout d'une surat</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field
                    v-model="suratNameArabe"
                    label="Surat en arabe"
                    outlined
                    placeholder="الفاتحة"
                    persistent-placeholder
                    :rules="rule"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field
                    v-model="suratNameFrancais"
                    label="Surat en français"
                    :rules="rule"
                    required
                    persistent-placeholder
                    placeholder="الفاتحة : Prologue"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field
                    v-model="suratNameAnglais"
                    label="Surat en anglais"
                    outlined
                    :rules="rule"
                    placeholder="AL-FATIHA : الفاتحة"
                    persistent-placeholder
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                  <v-text-field
                    v-model="arabicTranslatedName"
                    label="Surat en arabe traduite"
                    outlined
                    :rules="rule"
                    placeholder="AL-FATIHA : الفاتحة"
                    persistent-placeholder
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="rangSurat"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    label="Rang de la surat"
                    :rules="rule"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="ordreChronologique"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    label="Ordre chronologique de la surat"
                    :rules="rule"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="numVerset"
                    hide-details
                    outlined
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    label="nombre de verset"
                    :rules="rule"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    v-model="type"
                    :items="['MECCAN','MEDIAN']"
                    label="Type de surat"
                    outlined
                    required
                    :rules="rule"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor
                    v-model="about"
                    auto-grow
                    outlined
                    label="A propos"
                    :rules="rule"
                    placeholder=" A propos"
                  >
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor
                    v-model="aboutEn"
                    auto-grow
                    outlined
                    label="About"
                    :rules="rule"
                    placeholder="About"
                  >
                  </VueEditor>
                </v-col>
              </v-row>
              <v-row> </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn
                      class="ml-6 mt-4"
                      color="info"
                      @click="validate"
                      :loading="loadingAddSurat"
                    >
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des surats</v-card-title>
      <v-text-field
        style="padding: 15px"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        clearable
        :search="search"
      ></v-text-field>
      <v-data-table
        :search="search"
        :loading="isLoadingTables"
        loading-text="Loading..."
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 30],
        }"
        :headers="headers"
        :items="suratArray"
        class="elevation-1"
      >
        <template v-slot:[`item.modifier`]="{ item }">
          <v-icon @click="updateInfosSurat(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
        <template v-slot:[`item.supprimer`]="{ item }">
          <v-icon @click="suppressionIcon(item.suratId)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogEditSurat" persistent width="1024">
        <v-card>
          <v-card-title>
            <span class="text-h5">Surat informations</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      v-model="surat.arabicName"
                      label="Surat en arabe"
                      outlined
                      placeholder="الفاتحة"
                      persistent-placeholder
                      :rules="rule"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      v-model="surat.frenchName"
                      label="Surat en français"
                      :rules="rule"
                      required
                      persistent-placeholder
                      placeholder="الفاتحة : Prologue"
                      outlined
                    ></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      v-model="surat.englishName"
                      label="Surat en anglais"
                      :rules="rule"
                      required
                      persistent-placeholder
                      placeholder="الفاتحة : Prologue"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="surat.arabic_translated_name"
                      label="Surat en arabe traduite"
                      outlined
                      :rules="rule"
                      placeholder="AL-FATIHA : الفاتحة"
                      persistent-placeholder
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="surat.rank"
                      hide-details
                      outlined
                      type="number"
                      oninput="if(this.value < 1) this.value = 1;"
                      label="Rang de la surat"
                      :rules="rule"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="surat.rank_by_revelation"
                      hide-details
                      outlined
                      type="number"
                      oninput="if(this.value < 1) this.value = 1;"
                      label="Ordre chronologique de la surat"
                      :rules="rule"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="surat.versetNumber"
                      hide-details
                      outlined
                      type="number"
                      oninput="if(this.value < 1) this.value = 1;"
                      label="nombre de verset"
                      :rules="rule"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="surat.type"
                      :items="['MECCAN','MEDIAN']"
                      label="Type de surat"
                      outlined
                      required
                      :rules="rule"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <VueEditor
                      v-model="surat.about"
                      auto-grow
                      outlined
                      label="A propos"
                      :rules="rule"
                      placeholder=" A propos"
                    >
                    </VueEditor>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <VueEditor
                      v-model="surat.aboutEn"
                      auto-grow
                      outlined
                      label="About"
                      :rules="rule"
                      placeholder="About"
                    >
                    </VueEditor>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" text @click="dialogEditSurat = false">
              Annuler
            </v-btn>
            <v-btn
              color="info darken-1"
              text
              @click="validateEdit()"
              :loading="loadingEditSurat"
            >
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogAddSurat" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir ajouter la surat ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="reinitialisationFormulaire()"
            >
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              text
              @click="ajoutSurat()"
              :loading="loadingAddSurat"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteSurat" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer la surat ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogDeleteSurat = false"
            >
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteSurat()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogConfirmEditSurat" max-width="600">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir Mettre à jour les informations de la surat?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1 error"
              text
              @click="dialogConfirmEditSurat = false"
            >
              Annuler
            </v-btn>

            <v-btn
              color="info darken-1 "
              text
              @click="updateSurat()"
              :loading="loadingEditSurat"
            >
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import { mdiPlus, mdiDeleteOutline, mdiPencil } from "@mdi/js";
import Constant from "@/utils/constants";
import { getAllSurat } from "@/views/qorani/services/services";
import { component as VueCodeHighlight } from "vue-code-highlight";

export default {
  components: { VueEditor, VueCodeHighlight },
  data() {
    return {
      about: "",
      aboutEn: "",
      search: "",
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
      },
      suratArray: [],
      isLoadingTables: false,
      valid: true,
      rule: [(v) => !!v || "Ce champ est requis"],
      suratNameArabe: "",
      suratNameFrancais: "",
      type: "",
      suratNameAnglais: "",
      arabicTranslatedName: "",
      rangSurat: null,
      numVerset: null,
      ordreChronologique: null,
      surat: {
        arabicName: "",
        frenchName: "",
        englishName: "",
        arabic_translated_name: "",
        rank: null,
        rank_by_revelation: null,
        versetNumber: null,
        type: null,
      },
      loadingAddSurat: false,
      dialogAddSurat: false,
      headers: [
        { text: "Surat en arabe", value: "arabicName", align: "center" },
        { text: "Surat en français", value: "frenchName", align: "center" },
        { text: "Surat en anglais", value: "englishName", align: "center" },
        {
          text: "Surat en arabe traduite",
          value: "arabic_translated_name",
          align: "center",
        },
        { text: "Rang", value: "rank", align: "center" },
        {
          text: "Ordre chronologique",
          value: "rank_by_revelation",
          align: "center",
        },
        { text: "Type de surat", value: "type", align: "center" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      dialogDeleteSurat: false,
      dialogEditSurat: false,
      loadingEditSurat: false,
      dialogConfirmEditSurat: false,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.ajoutSurat();
      }
    },
    validateEdit() {
      if (this.$refs.form.validate()) {
        this.updateSurat();
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddSurat = false;
      this.$refs.form.reset();
    },
    //Fonction ajout surat
    async ajoutSurat() {
      this.loadingAddSurat = true;
      this.surat.arabicName = this.suratNameArabe;
      this.surat.frenchName = this.suratNameFrancais;
      this.surat.englishName = this.suratNameAnglais;
      this.surat.arabic_translated_name = this.arabicTranslatedName;
      this.surat.versetNumber = Number(this.numVerset);
      this.surat.rank = Number(this.rangSurat);
      this.surat.rank_by_revelation = Number(this.ordreChronologique);
      this.surat.about = this.about;
      this.surat.aboutEn = this.aboutEn;
      this.surat.type = this.type;

      const responseCategorie = await fetch(Constant.QORANI + "surat/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.surat),
      });

      try {
        this.loadingAddSurat = false;
        this.dialogAddSurat = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout de la surat, veuillez réessayez plus tard, Merci."
        );
      }
    },

    //Affichage de la boite de dialog de confirmation de suppression
    suppressionIcon(item) {
      this.idSuratSupprimer = item;
      this.deleteSurat();
    },
    //Permt la suppression d'une surat
    async deleteSurat() {
      const responseCategorie = await fetch(
        Constant.QORANI + `surat/delete/${this.idSuratSupprimer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteSurat = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression de la surat, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteSurat = false;
      }
    },
    //Permet au clic sur icone modifier l'affichage informations surat
    updateInfosSurat(item) {
      this.dialogEditSurat = true;
      this.surat = item;
      this.idSuratAModifier = item.suratId;
    },
    //Fonction mise a jour informations surat
    async updateSurat() {
      this.loadingEditSurat = true;
      this.surat.versetNumber = Number(this.surat.versetNumber);
      this.surat.rank = Number(this.surat.rank);
      this.surat.rank_by_revelation = Number(this.surat.rank_by_revelation);

      const responseCategorie = await fetch(
        Constant.QORANI + `surat/edit/${this.idSuratAModifier}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.surat),
        }
      );

      try {
        this.loadingEditSurat = false;
        this.dialogConfirmEditSurat = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la mise à jour du juz, veuillez réessayez plus tard, Merci."
        );
        this.loadingEditSurat = false;
        this.dialogConfirmEditSurat = false;
      }
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.suratArray = await getAllSurat();
    this.isLoadingTables = false;
  },
};
</script>
<style scoped>
.v-text-field ::placeholder {
  font-weight: bold;
}
</style>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
